import { Heading, breakpoints } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const ReviewsWrapper = styled('div')`
  margin-top: 1.25rem;
  scroll-margin-top: 84px;

  @media (min-width: ${breakpoints.md}) {
    scroll-margin-top: 108px;
  }
  @media (min-width: ${breakpoints.lg}) {
    margin-top: 3rem;
  }
`;

export const ReviewCount = styled('span')`
  @media (min-width: ${breakpoints.md}) {
    display: none;
  }
`;

export const TitleWrapper = styled(Heading.H2)`
  text-align: left !important;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  flex-basis: 100%;
  margin-bottom: 1rem;
  gap: 0.4rem;

  font-size: 1rem;
  line-height: 1.18;
  font-weight: bold;

  @media (min-width: ${breakpoints.md}) {
    font-size: 1.75rem !important;
    display: block;
    cursor: text;
    margin-bottom: 2rem;
  }
`;
